"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var map = {};
exports.default = (function (prefix) {
    prefix = prefix || 'g';
    if (!map[prefix]) {
        map[prefix] = 1;
    }
    else {
        map[prefix] += 1;
    }
    return prefix + map[prefix];
});
//# sourceMappingURL=unique-id.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/unique-id.js
// module id = 1157
// module chunks = 37